'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseTooltip=require('../../../../dist-es6/client/directives/tooltips/baseTooltip');let

BaseControllerBackedTooltip=class BaseControllerBackedTooltip extends BaseTooltip{
factory(){
return Object.assign({},super.factory(),{
controller:this.controller,
controllerAs:'controller',
bindToController:!0,
link:{
pre:scope=>{
if(_.exists(this.bindings)){

for(const binding of this.bindings){
scope.controller[binding]=scope.bindings[binding];
}
}else{

scope.controller=scope.bindings;
}
}}});


}};


module.exports=BaseControllerBackedTooltip;
//# sourceMappingURL=baseControllerBackedTooltip.js.map
